module.exports = require("core-js/modules/es.parse-float.js");